import { z } from 'zod';
export const RefreshResponse = z.object({
    accessToken: z.string(),
}).strict();
